import { debounce } from 'lodash';

type AnalyticsMethod = (eventId: string, params?: Json) => void;

export let sendAnalytics: AnalyticsMethod,
  sendAnalyticsD: AnalyticsMethod,
  bridge: any = null,
  webAssetsUrl: string = '';

export const setAnalyticsMethod = (method: AnalyticsMethod) => {
  sendAnalytics = method;
  sendAnalyticsD = debounce(method, 1000);
};

export const setBridge = (b: any) => {
  bridge = b;
};

export const setWebAssetsUrl = (url: string) => {
  webAssetsUrl = url;
};
